module.exports = "<div class=\"fast-forward-components\">\n  <div class=\"forward-btn forward-left\"></div>\n  <div class=\"forward-btn forward-right\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/lesson/play/components/aliplayer/components/FastForwardComponent/index.html
// module id = uNPn
// module chunks = 2